import { observer } from "mobx-react-lite";
import useDefaultMapLayer from "../../hooks/useDefaultMapLayer";
import ILayerProps from "../../interfaces/IlayerProps";

function OpportunityZonesMapLayer({ visible }: ILayerProps) {
    useDefaultMapLayer(visible, () => [
        "Opportunity Zone Layer",
    ]);

    return (
        <></>
    );
}

export default observer(OpportunityZonesMapLayer);